import quarkusApi from '../api/quarkusApi';

// Marca entradas e saídas vencidas como atrasadas antes de listar. O backend deixou de fazer isso
// por agendamento, então a atualização acontece quando o usuário entra em Entradas ou Saídas.
// A operação é idempotente e nunca deve impedir a listagem: se falhar, seguimos com o GET.
export function updateOverDueFinancialStatus() {
  return quarkusApi
    .post('/financial/overdue-status', null, {
      headers: { Authorization: sessionStorage.getItem('token') },
    })
    .catch((returnFromApi) => {
      console.error('ops! ocorreu um erro' + returnFromApi);
    });
}
